import { Col, Row } from 'antd';
import { FieldHelperProps, FieldInputProps, FieldMetaProps } from 'formik';
import { FC, useEffect, useMemo } from 'react';
import { FormItem, InputDiv, LabelDiv } from './styles';
import { StyledRef } from 'components/new-ui/base/ref/styles';
import { ErrorLabel } from '../formInput/styles';
import IconTooltip from 'components/new-ui/base/tooltip/IconTooltip';
import { StyledLabel } from '../declarations/formInput/styles';
import { StyledTextArea } from 'components/new-ui/base/text-area/styles';
import { TextAreaProps } from 'antd/lib/input';
import LabelRequiredSymbol from 'components/new-ui/base/label/LabelRequiredSymbol';

export interface FormTextAreaProps extends TextAreaProps {
    label?: string;
    fieldProps: FieldInputProps<any>;
    fieldMeta?: FieldMetaProps<any>;
    fieldHelper?: FieldHelperProps<any>;
    disabled?: boolean;
    required?: boolean;
    maxLength?: number;
    rows?: number;
    placeholder?: string;
    refNumber?: string;
    tooltip?: string;
    condensed?: boolean;
}

const FormTextArea: FC<FormTextAreaProps> = ({
    label,
    fieldMeta,
    fieldProps,
    fieldHelper,
    disabled,
    required,
    maxLength,
    rows = 4,
    placeholder,
    refNumber,
    tooltip,
    ...rest
}) => {
    const showTooltip = useMemo(() => tooltip && tooltip.length > 0, [tooltip]);

    useEffect(() => {
        if (fieldProps.value === '' && fieldHelper) {
            fieldHelper.setValue(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fieldProps.value]);

    if (label) {
        return (
            <Row>
                <Col span={10}>
                    <LabelDiv style={{ alignItems: 'start' }}>
                        {refNumber && <StyledRef>{refNumber}</StyledRef>}
                        {label && (
                            <StyledLabel>
                                {required && <LabelRequiredSymbol />}
                                <span>{label}</span>
                                {showTooltip && <IconTooltip title={label} />}
                                <span>:</span>
                            </StyledLabel>
                        )}
                    </LabelDiv>
                </Col>
                <Col span={14}>
                    <FormItem validateStatus={fieldMeta?.error && !!fieldMeta?.touched ? 'error' : ''}>
                        <InputDiv>
                            <StyledTextArea
                                $hasError={!!fieldMeta?.error && !!fieldMeta?.touched}
                                id={fieldProps.name}
                                placeholder={placeholder}
                                rows={rows}
                                disabled={disabled}
                                maxLength={maxLength}
                                {...fieldProps}
                                {...rest}
                            />
                        </InputDiv>
                        <div>
                            {!!fieldMeta?.error && !!fieldMeta?.touched && <ErrorLabel>{fieldMeta?.error}</ErrorLabel>}
                        </div>
                    </FormItem>
                </Col>
            </Row>
        );
    }

    return (
        <FormItem validateStatus={fieldMeta?.error && !!fieldMeta?.touched ? 'error' : ''}>
            <InputDiv>
                <StyledTextArea
                    $hasError={!!fieldMeta?.error && !!fieldMeta?.touched}
                    id={fieldProps.name}
                    placeholder={placeholder}
                    rows={rows}
                    disabled={disabled}
                    maxLength={maxLength}
                    {...fieldProps}
                    {...rest}
                />
            </InputDiv>
            <div>{!!fieldMeta?.error && !!fieldMeta?.touched && <ErrorLabel>{fieldMeta?.error}</ErrorLabel>}</div>
        </FormItem>
    );
};

export default FormTextArea;
